import React from 'react';
import useFeatureToggleService from 'feature-toggle';
import { TextBadgeLayoutProps, TextBadgeVariant } from '../types';
import ShadcnTextBadgeLayout from './ShadcnTextBadgeLayout';

import styles from './TextBadgeLayout.module.scss';

function LegacyTextBadgeLayout(props: TextBadgeLayoutProps) {
  const { text, variant = TextBadgeVariant.PRIMARY } = props;

  const classes = [
    styles.badge,
    styles[variant],
    props.isSmall ? styles.small : styles.large
  ]

  return (
    <span className={classes.join(' ')} title={props.title}>
      {text}
    </span>
  );
}

export default function TextBadgeLayoutWeb(props: TextBadgeLayoutProps) {
  const { isShadcnUiEnabled } = useFeatureToggleService();

  if (isShadcnUiEnabled()) {
    return <ShadcnTextBadgeLayout {...props} />;
  } else {
    return <LegacyTextBadgeLayout {...props} />;
  }
}
